import React, { FC } from 'react';
import { TooltipComponent } from 'src/common/tooltip/component';

type Props = {
  tooltip: string;
};

export const TableHeaderWithTooltip: FC<Props> = ({ tooltip, children }) => {
  return (
    <div className='flex'>
      <TooltipComponent placement='top' tooltipContent={tooltip} styling='tooltip' theme='journey'>
        {children}
      </TooltipComponent>
    </div>
  );
};
